import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Refundpolicy() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#030712] text-slate-900 dark:text-slate-200 font-body py-16 px-4 sm:px-6 transition-colors duration-300">
      <div className="max-w-4xl mx-auto space-y-8 glass-panel p-8 md:p-12 rounded-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-bold text-blue-600 dark:text-cyan-400 hover:underline font-heading">
          <ArrowLeft size={14} /> Back to Home
        </Link>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-600 dark:text-cyan-400 font-heading">Contract Terms</span>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900 dark:text-white">Refund Policy</h1>
          <p className="text-xs text-slate-500 dark:text-slate-400">Last updated: August 2026</p>
        </div>

        <div className="space-y-6 text-sm text-slate-700 dark:text-slate-300 leading-relaxed font-medium">
          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">1. Milestone Payments</h3>
            <p>
              Project milestone payments correspond to specific deliverables (System Study, Prototyping, Code Build, UAT). Payments for completed and approved milestones are non-refundable.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">2. Pre-Execution Cancellation</h3>
            <p>
              If a client cancels a project before engineering execution begins, a partial refund will be processed minus administrative and preliminary architecture fees.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
